import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
const ILanguageFeaturesService = ( createDecorator('ILanguageFeaturesService'));
export { ILanguageFeaturesService };
